module.exports = " <div> <player-search></player-search> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** /home/onlygamescl/onlygames-front/shared/~/vue-html-loader!/home/onlygamescl/onlygames-front/shared/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/configuration/Players.vue
 ** module id = 307
 ** module chunks = 1
 **/